// extracted by mini-css-extract-plugin
module.exports = {"container":"Authorised_container__3tIZg","extraCopy":"Authorised_extraCopy__24kM4","title":"Authorised_title__1ayqK","shield":"Authorised_shield__1IGD2"};